import { storyblokEditable } from "@storyblok/react/rsc";
import { FC } from "react";
import { Container } from "../layout/container";
import { FAQItem } from "./FAQItem";
import { Accordion } from "@/components/ui/accordion";
import { FaqStoryblok } from "@/types/sb-component-types";
interface FAQProps {
  blok: FaqStoryblok;
}
export const FAQ: FC<FAQProps> = ({
  blok
}) => {
  return <Container {...storyblokEditable(blok)} className="py-12" data-sentry-element="Container" data-sentry-component="FAQ" data-sentry-source-file="FAQ.tsx">
      <div className="mx-auto max-w-3xl">
        <Accordion collapsible className="w-full" type="single" data-sentry-element="Accordion" data-sentry-source-file="FAQ.tsx">
          {blok.faq_items?.map(item => <FAQItem key={item._uid} blok={item} />)}
        </Accordion>
      </div>
    </Container>;
};